<template>
  <div class="comments">
    <div class="top">
      <div class="title">Comentários</div>
    </div>
    <div class="content" v-if="comments.length > 0">
      <div class="box" v-for="c in comments" :key="c.id">
        <div
          class="avatar"
          :style="{
            backgroundImage: `url('${avatarUrl(c.autor, { head_direction: 3, headonly: 0 })}')`,
          }"
        ></div>
        <div class="text">
          <div
            class="autor"
            @click="
              () => {
                showP = true
                perfilName = c.autor
              }
            "
          >
            {{ c.autor }} <span>{{ c.time !== 'Agora' ? c.time + ' atrás' : 'Agora' }}</span>
          </div>
          <div class="resp-actions" v-show="store.logged == 'true' || store.logged">
            <span
              @click="() => { showR = true; modId = c.id; modPId = id }"
            >Responder</span>
            <span
              v-if="store.initUser?.id && String(store.initUser.id) === String(c.id_user)"
              class="del-btn"
              @click="delCom(c.id)"
            >Apagar</span>
          </div>
          <span class="comment" v-html="c.text"></span>
        </div>

        <div class="response" v-for="(cc, i) in c.responses" :key="i">
          <div
            class="avatar"
            :style="{
              backgroundImage: `url('${avatarUrl(cc.user, { head_direction: 3, headonly: 0 })}')`,
            }"
          ></div>
          <div class="text">
            <div
              class="autor"
              @click="
                () => {
                  showP = true
                  perfilName = cc.user
                }
              "
            >
              {{ cc.user }} <span>{{ cc.time !== 'Agora' ? cc.time + ' atrás' : 'Agora' }}</span>
            </div>
            <span class="comment" v-html="cc.response"></span>
          </div>
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
    <Transition name="slide-fade">
      <PostResponse
        v-if="showR"
        @close="() => { showR = false; getCom() }"
        :id="modId"
        :post_id="modPId"
        :type="type"
      />
    </Transition>
  </div>
</template>

<script setup>
import { getComments, deleteComment, avatarUrl } from '@/services/api.js'
import ItemPerfil from '@/components/modals/perfil.vue'
import PostResponse from '@/components/modals/post-comment-response.vue'
import { ref } from 'vue'
import { useStore } from '@/stores/index.js'

const store = useStore()

const props = defineProps({
  id: {
    type: [Number, String, Object],
    required: true,
  },
  type: {
    type: [String, Object],
    required: true,
  },
})

const comments = ref([])
const showP = ref(false)
const showR = ref(false)
const perfilName = ref('')
const modId = ref(0)
const modPId = ref(0)

async function getCom() {
  const data = await getComments(props.type, props.id)
  comments.value = data.comments ?? []
}

async function delCom(commentId) {
  if (!confirm('Apagar comentário?')) return
  await deleteComment(props.type, commentId)
  getCom()
}

getCom()
</script>

<style scoped>
.comments .box .text {
  position: relative;
  background-color: #f8f9fb;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.comments .box .text .autor {
  position: relative;
  float: left;
  height: 20px;
  font-size: 15px;
  font-weight: 800;
  color: var(--color1);
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}

.comments .box .text .autor span {
  color: #6d6d6d;
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
}

@media only screen and (max-width: 500px) {
  .comments .box .text .autor {
    height: auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    line-height: 1.3;
    padding-bottom: 2px;
  }
}

.comments .box .text > span {
  font-size: 16px;
}

.comments .box .text .comment {
  width: 100%;
  font-size: 15px;
}

.comments .box .resp {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.1s linear;
}

.comments .box .resp:hover {
  font-weight: 600;
  text-decoration: underline;
}

.comments .box .response {
  float: left;
  width: calc(100% - 60px);
  height: auto;
  margin: 8px 0 0 60px;
}
</style>
